import { useMutation } from '@tanstack/react-query';

import useCredentials from 'api/hook/useCredentials';
import { baseAxios, handleError } from 'api';

export function useVerifyPolicy() {
  const authAxios = useCredentials();
  return useMutation({
    mutationFn: (data) =>
      baseAxios(authAxios, {
        url: '/policy/verify_api',
        method: 'post',
        data,
      }),
    onError: handleError,
  });
}
